<div class="back-img new-login-banners">
  <mat-carousel timings="250ms ease-in"
    [autoplay]="true"
    interval="5000"
    color="accent"
    maxWidth="77%"
    proportion="25"
    slides="5"
    [loop]="true"
    [hideArrows]="true"
    [hideIndicators]="true"
    [useKeyboard]="true"
    [useMouseWheel]="false"
    orientation="ltr">
    <mat-carousel-slide #matCarouselSlide
      *ngFor="let slide of banners; let i = index"
      [image]="slide.imageUrl"
      overlayColor="#00000040"
      [hideOverlay]="false"></mat-carousel-slide>
  </mat-carousel>
</div>
